module.exports = __webpack_public_path__ + "img/con_frsr.3c38b6cb.png";